import { AppBar, Box, Drawer, List, Toolbar, useTheme } from '@mui/material';
import { IconBtn } from '../IconBtn/IconBtn';
import { Heading } from '../Heading/Heading';
import { useAuth } from '../../hooks/useAuth/useAuth';
import { useNavigate } from 'react-router-dom';
import { APP_PATHS } from '../../constants/paths';
import { appBarSx, padding12Sx, toolbarSx } from '../../styles/Global.style';
import {
  backBtnSx,
  drawerPaperPropsSx,
  listContainerSx,
  listItemSx,
  toolBarContentsContainerSx,
} from './NavDrawer.style';
import { Copy } from '../../copy/Copy';
import { Back } from '../../icons/Back/Back';
import { mapNavDrawerListItems } from '../../helpers/mapNavDrawerListItems';
import { ListItemTile } from '../ListItemTile/ListItemTile';
import { Admin } from '../../icons/Admin/Admin';

export const NavDrawer = ({ toggleDrawer, isSignedIn, isDrawerOpen }) => {
  const theme = useTheme();
  const { signOut } = useAuth();
  const navigate = useNavigate();
  const color = theme.palette.secondary.main;
  const isAdmin = false;

  const navigateInternal = (path) => {
    navigate(path);
    toggleDrawer();
  };

  const navigateExternal = (path) => {
    window.open(path);
    toggleDrawer();
  };

  const handleSignOut = async () => {
    if (isSignedIn) {
      await signOut();
      navigate(APP_PATHS.login);
    }
  };

  return (
    <Drawer
      anchor="right"
      open={isDrawerOpen}
      onClose={toggleDrawer}
      PaperProps={drawerPaperPropsSx(theme)}
    >
      <AppBar position="sticky" sx={appBarSx(theme)}>
        <Toolbar sx={toolbarSx} disableGutters>
          <Box sx={toolBarContentsContainerSx}>
            <IconBtn
              icon={<Back />}
              onClick={toggleDrawer}
              color={color}
              aria="Drawer back button"
              sx={backBtnSx}
            />

            <Heading text={Copy.generate('Global.more')} level={1} />
          </Box>
        </Toolbar>
      </AppBar>

      <Box sx={listContainerSx}>
        <List sx={padding12Sx}>
          {isAdmin && (
            <ListItemTile
              text={Copy.generate('Global.admin')}
              icon={<Admin />}
              onClick={() => navigateInternal(APP_PATHS.admin)}
              sx={listItemSx(theme)}
            />
          )}

          {mapNavDrawerListItems(
            navigateInternal,
            navigateExternal,
            handleSignOut,
          ).map((l, i) => (
            <ListItemTile
              key={i}
              text={Copy.generate(`Global.${l.name}`)}
              icon={l.icon}
              onClick={l.onClick}
              sx={listItemSx(theme)}
            />
          ))}
        </List>
      </Box>
    </Drawer>
  );
};
